import "core-js/modules/es6.regexp.split.js";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { colors } from '@nerdwallet/base-styles/variables';
import styles from "./image.module.css";

/**
 * Helper used to get the correct percentage to
 * apply to padding-bottom given a supported aspect
 * ratio size. For example, a 5:2 ratio is calculated by
 * dividing 2 by 5 to get 40%.
 *
 * @param {String} aspectRatio. For example, "5:2".
 * @returns {null | String} to be used as the appropriate percentage.
 */
var calculateAspectRatioPercentage = function calculateAspectRatioPercentage(aspectRatio) {
  if (!aspectRatio) {
    return null;
  }

  // Parse numbers out of supplied aspectRatio.
  var values = aspectRatio.toLowerCase().split(':');
  var width = parseFloat(values[0]);
  var height = parseFloat(values[1]);
  var percentage = height / width * 100;

  // Clamp to three decimal points
  return percentage.toFixed(3);
};
var Wrapper = function Wrapper(_ref) {
  var aspectRatio = _ref.aspectRatio,
    backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    className = _ref.className,
    placeholderImage = _ref.placeholderImage;
  var style = {
    backgroundColor: backgroundColor
  };
  if (placeholderImage) {
    style = {
      backgroundImage: "url(\"".concat(placeholderImage, "\")")
    };
  }

  // Conditionally calculate and inline padding-bottom percentage
  // to support an aspect ratio if the prop is supplied
  if (aspectRatio) {
    style.paddingBottom = "".concat(calculateAspectRatioPercentage(aspectRatio), "%");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, className),
    style: style
  }, children);
};
Wrapper.defaultProps = {
  aspectRatio: null,
  backgroundColor: colors['neutral-lightest']
};
Wrapper.propTypes = {
  aspectRatio: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  placeholderImage: PropTypes.string
};
export default Wrapper;